import { type I18nLocale } from '@ardoq/i18n';
import { DatePickerGrid } from './components';
import { getMonthNamesShort } from './consts';

type SelectMonthProps = {
  readonly selectedMonth: number | null;
  readonly isMonthDisabled: (month: number) => boolean;
  readonly selectMonth: (month: number) => void;
  readonly i18nLocale: I18nLocale;
};

const SelectMonth = ({
  selectedMonth,
  isMonthDisabled,
  selectMonth,
  i18nLocale,
}: SelectMonthProps) => {
  const monthNames = getMonthNamesShort(i18nLocale);
  return (
    <DatePickerGrid
      items={monthNames.map((label, monthIndex) => ({
        id: String(monthIndex),
        label,
      }))}
      activeItemId={selectedMonth !== null ? String(selectedMonth) : null}
      onSelect={id => selectMonth(Number(id))}
      getIsDisabled={id => isMonthDisabled(Number(id))}
    />
  );
};

export { SelectMonth };
